import React from "react";
import PropTypes from "prop-types";
import StyledFilterTypeCheckbox from "./FilterTypeCheckbox.styled";
import SVGIcon from "../utility/SVGIcon";

const FilterTypeCheckbox = React.memo(props => {
  const { types, name, checkFilter, checked, disabled } = props;
  return (
    <StyledFilterTypeCheckbox className={`filter-product-type__checkbox ${checked && "is-checked"}`}>
      <SVGIcon className="filter-product-type__checkbox__svg-left" name="filter-svg-left" />
      <input disabled={disabled} checked={checked} onChange={() => checkFilter(types.uri_param, name, types.name)} aria-label={name} type="checkbox" />
      <span className="filter-product-type__checkbox__custom">
        {
            checked ?
                <div className='filter-product-type__checkbox-border'>
                    <SVGIcon name="filter-check" className="filter-product-type__checkbox__svg-checked"/>
                </div> :
                <SVGIcon name="filter-checkbox"/>
        }
      </span>
      <p className="t-body-small filter-product-type__checkbox__copy">{types.name}</p>
      <SVGIcon className="filter-product-type__checkbox__svg-right" name="filter-svg-right" />
    </StyledFilterTypeCheckbox>
  );
});

FilterTypeCheckbox.propTypes = {
  types: PropTypes.object.isRequired,
  checkFilter: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool
};

export default FilterTypeCheckbox;